import { seemsOffline } from "./connectivity";
import { isPwaEnabled } from "./offline_gating";

export const VIEW_RESULTS_OFFLINE_BANNER_MESSAGE =
  "Please connect to the internet to view your progress and proceed";

const QUIZ_RESULTS_SUMMARY_HREF = /\/quizzes\/\d+(?:\?|#|$)/;

export function isViewResultsSummaryLink(element) {
  const anchor =
    element?.closest?.("a[href]") || (element?.matches?.("a[href]") ? element : null);
  if (!anchor || anchor.target === "_blank") return false;
  if (anchor.classList.contains("player-summary-button")) return true;

  const href = anchor.getAttribute("href") || "";
  if (!QUIZ_RESULTS_SUMMARY_HREF.test(href)) return false;
  return /view results summary/i.test(anchor.textContent || "");
}

export function showViewResultsOfflineBanner(message = VIEW_RESULTS_OFFLINE_BANNER_MESSAGE) {
  const banner = document.getElementById("offline-quiz-complete");
  if (!banner) return false;
  banner.textContent = message;
  banner.classList.remove("hidden");
  return true;
}

export function hideViewResultsOfflineBanner() {
  const banner = document.getElementById("offline-quiz-complete");
  if (!banner) return false;
  banner.classList.add("hidden");
  return true;
}

if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    if (!isPwaEnabled()) return;
    hideViewResultsOfflineBanner();
  });
}

if (typeof document !== "undefined") {
  document.addEventListener(
    "click",
    (event) => {
      if (!isPwaEnabled() || !seemsOffline()) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;

      const clickable = event.target.closest?.("a, button");
      if (!clickable || !isViewResultsSummaryLink(clickable)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showViewResultsOfflineBanner();
    },
    true
  );
}
